export const FORM_URLENCODED = 'application/x-www-form-urlencoded';
export const MULTIPART_FORMDATA = 'multipart/form-data';
export const APPLICATION_JSON = 'application/json';